import React, { useState, useEffect } from "react";
import "./merchant-section.scss";
import { getAllMerchants, searchMerchant } from "../../../../requests/merchantApi";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const MerchantSection = () => {
  const [rows, setRows] = useState([]);
  const [searchQuery, setSearchQuery] = useState("")
  const navigate = useNavigate();

  const allChecked = rows?.every((row) => row.selected);

  const handleSelectAll = () => {
    const newValue = !allChecked;
    setRows(rows?.map((row) => ({ ...row, selected: newValue })));
  };

  const handleRowSelect = (index) => {
    const updated = [...rows];
    updated[index].selected = !updated[index].selected;
    setRows(updated);
  };

  const getAllMerchantsFun = async () => {
      const data = await getAllMerchants();
      if (data.status) {
        setRows(data.data);
      } else {
        toast.error(data.message)
      }
  };

  const handleSearch = async(e) => {
    const queryData = await searchMerchant(searchQuery)
    if(queryData.status) {
      setRows(queryData.data)
      if(!queryData.data.length) {
        toast.info("No records found.")
      }
    } else {
      toast.error(queryData.message)
    }
  };

  useEffect(() => {
    getAllMerchantsFun();
  }, []);

  return (
    <section className="merchant-page-section">
      <div className="search-input">
        <h5 className="form-title">Merchant Management</h5>
        <form action="">
          <div className="input-wrap">
            <img
              src="/images/icons/search-icon-input.svg"
              alt="search-icon-input"
            />
            <input
              type="text"
              placeholder="Search merchant name or email"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleSearch();
                }
              }}
            />
          </div>
        </form>
      </div>
      <div className="table-responsive">
        <table className="table table-striped vendor-info">
          <thead className="table-dark">
            <tr>
              {/* <th>
                <label className="custom-checkbox">
                  <input
                    type="checkbox"
                    checked={allChecked}
                    onChange={handleSelectAll}
                  />
                  <span className="checkmark"></span>
                </label>
              </th> */}
              <th>Merchant Name</th>
              <th>Status</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {rows?.map((row, i) => (
              <tr key={i}>
                {/* <td>
                  <label className="custom-checkbox">
                    <input
                      type="checkbox"
                      checked={row.selected}
                      onChange={() => handleRowSelect(i)}
                    />
                    <span className="checkmark"></span>
                  </label>
                </td> */}
                <td>{row.fullName}</td>
                <td>{row.approvalStatus}</td>
                <td>{row.email}</td>
                <td>{row.phone}</td>
                <td>
                  <div
                    className="more-details"
                    onClick={() =>
                      navigate("/merchant-details", { state: { data: row } })
                    }
                  >
                    More Details{" "}
                    <img
                      src="/images/icons/detail-arrow.svg"
                      alt="detail-arrow"
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default MerchantSection;
